<template>
  <master-layout pageTitle="Email">
    <div>
      <div v-if="!emailConnected" class="gridMargin">
        <div class="model-sections">
          <div class="cust-brdr sectionPadding">
            <div class="flex-start alignCenter gap10P">
              <img src="@/resources/images/email_icon.svg" class="emailLogo" alt="email_logo" width="40" />
              <p class="vtext-card-title">Connect Email</p>
            </div>
          </div>

          <div class="sectionPadding">
            <div class="margin10P">
              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-12 vcol-lg-12 vcol-md-12 vcol-sm-12 vcol-xs-12 colMargin">
                  <div class="flex-start">
                    <p class="vtext-subtitle vpb-10">Verified Domain<span class="important">*</span></p>
                    <HelpTooltip :iconStyle="{ paddingBottom: '10px' }"> The domain will be need to be verified by Vonage prior to sending emails. See the documentation for more information on setting up and verifying email domains. </HelpTooltip>
                  </div>
                  <VTextField v-model="verifiedDomain" placeholder="Enter verified domain" aria-label="Verified Domain" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>

              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                  <div class="flex-start">
                    <p class="vtext-subtitle vpb-10">Sender Email Address<span class="important">*</span></p>
                    <HelpTooltip :iconStyle="{ paddingBottom: '10px' }">
                      The verified email address of the message sender (for example, support@yourdomain.com).
                    </HelpTooltip>
                  </div>
                  <VTextField v-model="senderEmail" type="email" placeholder="Enter sender email" aria-label="Sender Email Address" appearance="ghost" class="vivid-input"></VTextField>
                </div>
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                  <div class="flex-start">
                    <p class="vtext-subtitle vpb-10">Display name (Optional)</p>
                    <HelpTooltip :iconStyle="{ paddingBottom: '10px' }">
                      Enter a display name to make your email more recognizable to recipients.
                      <ul>
                        <li>Display Name: Support</li>
                        <li>Recipient sees: Support support@yourdomain.com</li>
                      </ul>
                    </HelpTooltip>
                  </div>
                  <VTextField v-model="displayName" placeholder="Enter display name" aria-label="Display name" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>

              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                  <p class="vtext-subtitle vpb-10">API key<span class="important">*</span></p>
                  <VTextField v-model="apikey" placeholder="Enter API key" aria-label="API key" appearance="ghost" class="vivid-input"></VTextField>
                </div>
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                  <p class="vtext-subtitle vpb-10">API secret<span class="important">*</span></p>
                  <VTextField v-model="apisecret" placeholder="Enter API secret" aria-label="API secret" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>

              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                  <p class="vtext-subtitle vpb-10">App ID<span class="important">*</span></p>
                  <VTextField v-model="appid" placeholder="Enter App ID" aria-label="App ID" appearance="ghost" class="vivid-input"></VTextField>
                </div>
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                  <p class="vtext-subtitle vpb-10">App name<span class="important">*</span></p>
                  <VTextField v-model="appname" placeholder="Enter App name" aria-label="App name" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>

              <div class="vmb-20">
                <p class="vtext-subtitle vpb-10">Private key <span class="important">*</span></p>
                <VTextArea v-model="privatekey" aria-label="private key" placeholder="Enter Private key" appearance="ghost" class="vivid-textarea"></VTextArea>
              </div>
            </div>

            <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Submit" :disabled="disabled" @click="connectEmail"></VButton>
          </div>
        </div>
      </div>

      <div v-else class="gridMargin">
        <div class="channel-container">
          <div class="cust_brdr optionsContainer flexContainer vmb-20">
            <div class="flexContainer">
              <div class="channel-icon-wrap">
                <img src="@/resources/images/email_icon.svg" width="40" alt="email_logo" class="iconImg" />
                <VerificationBadge
                  class="channel-verification-badge"
                  :verified="isChannelVerified('email')"
                  :error-message="verificationErrorFor('email')"
                />
              </div>
              <h2 class="vtext-card-title">{{ emailSocialData?.appname || emailSocialData?.account_name || 'Email' }}</h2>
            </div>
            <VButton class="vvd-btn-danger-outline" connotation="announcement" appearance="outlined" label="Disconnect" @click="disconnectPageMode = true"></VButton>
          </div>

          <div class="optionsContainer cust_brdr vmb-20">
            <div class="sender-info-row">
              <p class="vtext-subtitle">Verified Domain</p>
              <p class="vtext-body">{{ emailSocialData?.verified_domain || '-' }}</p>
            </div>
            <div class="sender-info-row">
              <p class="vtext-subtitle">App ID</p>
              <div class="config-field-wrap">
                <VTextField
                  v-model="connectedAppId"
                  placeholder="Enter App ID"
                  aria-label="Connected App ID"
                  appearance="ghost"
                  class="vivid-input"
                ></VTextField>
              </div>
            </div>
            <div class="config-private-key-row">
              <div>
                <p class="vtext-subtitle paddingBottom">Private key</p>
                <VTextArea
                  v-model="connectedPrivateKey"
                  aria-label="Connected private key"
                  placeholder="Enter Private key"
                  appearance="ghost"
                  class="vivid-textarea"
                ></VTextArea>
                <div class="config-actions">
                  <VButton
                    class="vvd-btn-primary"
                    connotation="cta"
                    appearance="filled"
                    label="Update"
                    :disabled="!canUpdateChannelConfig"
                    @click="updateEmailChannelConfig"
                  ></VButton>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="sub-title marginBottom">Sender Email Addresses</div>
            <!-- Sender Emails List -->
            <div v-if="senderEmailsArray.length > 0" class="senderContainer vmb-10">
              <div class="sender-row sender-header">
                <div class="sender-cell flex-start">
                  <p class="vtext-section-header--bold">Sender Email Address</p>
                  <HelpTooltip :iconStyle="{ paddingTop: '1px' }">
                    The sender email address for this message (for example, support@yourdomain.com). The domain must be verified by Vonage before sending.
                  </HelpTooltip>
                </div>
                <div class="sender-cell">
                  <div class="flex-start">
                    <span class="vtext-section-header--bold">Display name</span>
                    <HelpTooltip :iconStyle="{ paddingTop: '1px' }">
                      Enter a display name to make your email more recognizable to recipients.
                      <ul>
                        <li>Display Name: Support</li>
                        <li>Recipient sees: Support support@yourdomain.com</li>
                      </ul>
                    </HelpTooltip>
                  </div>
                </div>
                <div class="sender-cell"><span class="vtext-section-header--bold">Recipient's inbox preview</span></div>
                <div class="sender-cell text-right"><span class="vtext-section-header--bold">Set as default</span></div>
                <div class="sender-cell text-right"><span class="vtext-section-header--bold">Action</span></div>
              </div>
              <div v-for="(item, index) in senderEmailsArray" :key="index" class="sender-row cust-brdr">
                <div class="sender-cell"><span class="vtext-body">{{ item.email }}</span></div>
                <div class="sender-cell"><span class="vtext-body">{{ item.displayName || '-' }}</span></div>
                <div class="sender-cell"><span class="vtext-body vtext-muted">{{ item.displayName ? `${item.displayName} <${item.email}>` : item.email }}</span></div>
                <div class="sender-cell text-right">
                  <VSwitch
                    :checked="item.isDefault"
                    @change="(e) => { if (e.target.checked) setAsDefault(index); }"
                    connotation="cta"
                    :disabled="senderEmailsArray.filter(i => i.isDefault).length === 1 && item.isDefault"
                  ></VSwitch>
                </div>
                <div class="sender-cell text-right">
                  <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" :disabled="senderEmailsArray.filter(i => i.isDefault).length === 1 && item.isDefault" @click="deleteSenderEmail(item.email)"></VIcon>
                </div>
              </div>
            </div>
            <div class="flex-start width100P gap10P newsenderContainer">
              <VTextField v-model="newSenderEmail" type="email" placeholder="Add a new Sender Email Address" aria-label="Sender Email" appearance="ghost" class="vivid-input"></VTextField>
              <VTextField v-model="newDisplayName" placeholder="Add a Display Name (Optional)" aria-label="Display name" appearance="ghost" class="vivid-input"></VTextField>
              <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add" :disabled="!newSenderEmail.length || senderEmailsArray.length >= 30" @click="addSenderEmail"></VButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <VDialog :open="disconnectPageMode" headline="Are you sure?" modal @close="disconnectPageMode = false">
      <template #body>
        <p class="vtext-body">You want to disconnect your Email account?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="disconnectPageMode = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="disconnectEmail"></VButton>
      </template>
    </VDialog>

    <VDialog :open="showReconnectDialog" headline="Reconnect Account" modal @close="showReconnectDialog = false">
      <template #body>
        <p class="vtext-body">This appears to be previously disconnected account, connecting this will show the data associated with that connection. Do you want to proceed?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="No" @click="showReconnectDialog = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="reconnectEmail"></VButton>
      </template>
    </VDialog>

    <!-- Delete Sender Email Confirmation Dialog -->
    <VDialog :open="showDeleteConfirmation" headline="Are you sure?" modal @close="showDeleteConfirmation = false; deleteEmailId = ''">
      <template #body>
        <p class="vtext-body">You want to remove this sender email?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="showDeleteConfirmation = false; deleteEmailId = ''"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="confirmDeleteSenderEmail"></VButton>
      </template>
    </VDialog>
  </master-layout>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import HelpTooltip from '@/components/HelpTooltip.vue';
import VerificationBadge from '@/components/VerificationBadge.vue';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useConnectionVerification } from '@/composables/useConnectionVerification';
import { environment } from '@/shared/env';
import { useAuthStore } from '@/stores/auth';
import { isValidEmail as isValidEmailHelper, validateSenderDomain } from '@/helpers/email.helpers';

const EMAIL_API_BASE = environment('VUE_APP_API_URL') + 'social/v1/email';

export default {
  components: { HelpTooltip, VerificationBadge },
  setup() {
    const { emailConnected, emailSocialData } = useSocialChannels();
    // Verify only this channel via ?channels=email
    const { isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel } = useConnectionVerification(['email']);
    return { emailConnected, emailSocialData, isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel };
  },
  data() {
    return {
      verifiedDomain: '',
      senderEmail: '',
      displayName: '',
      appid: '',
      appname: '',
      apikey: '',
      apisecret: '',
      privatekey: '',
      disconnectPageMode: false,
      showReconnectDialog: false,
      senderEmailsArray: [],
      newSenderEmail: '',
      newDisplayName: '',
      showDeleteConfirmation: false,
      deleteEmailId: '',
      connectedAppId: '',
      connectedPrivateKey: '',
      initialConnectedAppId: '',
      initialConnectedPrivateKey: ''
    }
  },
  mounted() {
    try {
      if (this.emailConnected) {
        this.manageSenderEmails();
      }
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    disabled() {
      return !this.verifiedDomain.length || !this.senderEmail.length || !this.apikey.length || !this.apisecret.length || !this.appid.length || !this.appname.length || !this.privatekey.length;
    },
    canUpdateChannelConfig() {
      const appId = this.connectedAppId?.trim() || '';
      const privateKey = this.connectedPrivateKey?.trim() || '';
      const initialAppId = this.initialConnectedAppId?.trim() || '';
      const initialPrivateKey = this.initialConnectedPrivateKey?.trim() || '';

      return Boolean(appId && privateKey && (appId !== initialAppId || privateKey !== initialPrivateKey));
    }
  },
  watch: {
    emailSocialData: {
      immediate: true,
      handler() {
        this.syncConnectedConfigFromSocialData();
      }
    }
  },
  methods: {
    async connectEmail() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Connecting Email account...' });
        const reqBody = {
          from_email: this.senderEmail,
          from_display_name: this.displayName,
          verified_domain: this.verifiedDomain,
          api_key: this.apikey,
          api_secret: this.apisecret,
          applicationid: this.appid,
          appname: this.appname,
          privatekey: this.privatekey,
          confirm: false
        };

        const response = await apiInterceptor.post(EMAIL_API_BASE, reqBody);

        if (response.data === null && response.dialogMessage) {
          useUIStore().updateLoading({ isLoading: false });
          this.showReconnectDialog = true;
          return;
        }

        useUIStore().updateToast({ open: true, message: 'Your Email account is now connected!', type: 'success' });

        const refreshEvent = new CustomEvent('refresh-customers', {
          detail: {
            action: 'connect',
            channel: 'email',
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);

        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('email');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Something went wrong', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async reconnectEmail() {
      try {
        this.showReconnectDialog = false;
        useUIStore().updateLoading({ isLoading: true, message: 'Reconnecting Email account...' });
        const reqBody = {
          from_email: this.senderEmail,
          from_display_name: this.displayName,
          verified_domain: this.verifiedDomain,
          api_key: this.apikey,
          api_secret: this.apisecret,
          applicationid: this.appid,
          appname: this.appname,
          privatekey: this.privatekey,
          confirm: true
        };

        await apiInterceptor.post(EMAIL_API_BASE, reqBody);

        useUIStore().updateToast({ open: true, message: 'Your Email account is now connected!', type: 'success' });

        const refreshEvent = new CustomEvent('refresh-customers', {
          detail: {
            action: 'connect',
            channel: 'email',
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);

        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('email');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Failed to reconnect account', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async disconnectEmail() {
      try {
        this.disconnectPageMode = false;
        useUIStore().updateLoading({ isLoading: true, message: 'Disconnecting Email account...' });

        await apiInterceptor.delete(EMAIL_API_BASE);

        useUIStore().updateToast({ open: true, message: 'Your Email Account is now disconnected!', type: 'success' });
        // Disconnected channels are never verified — clear the status locally.
        this.invalidateChannel('email');
        this.resetData();

        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();

        const refreshEvent = new CustomEvent('refresh-customers', {
          detail: {
            action: 'disconnect',
            channel: 'email',
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Something went wrong', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    resetData() {
      this.verifiedDomain = '';
      this.senderEmail = '';
      this.displayName = '';
      this.appid = '';
      this.appname = '';
      this.apikey = '';
      this.apisecret = '';
      this.privatekey = '';
      this.senderEmailsArray = [];
      this.newSenderEmail = '';
      this.newDisplayName = '';
      this.connectedAppId = '';
      this.connectedPrivateKey = '';
      this.initialConnectedAppId = '';
      this.initialConnectedPrivateKey = '';
    },
    syncConnectedConfigFromSocialData() {
      const socialData = this.emailSocialData || {};
      const appId = socialData.applicationid || socialData.appid || '';
      const privateKey = socialData.privatekey || '';

      this.connectedAppId = appId;
      this.connectedPrivateKey = privateKey;
      this.initialConnectedAppId = appId;
      this.initialConnectedPrivateKey = privateKey;
    },
    manageSenderEmails() {
      if (this.emailSocialData?.sender_ids?.length) {
        const defaultEmail = this.emailSocialData.default_sender_id || this.emailSocialData.default_sender_email;
        const newSenderEmails = this.emailSocialData.sender_ids.map((item) => {
          if (typeof item === 'string') {
            const [email, ...displayParts] = item.split(':');
            const displayName = displayParts.join(':');
            return {
              email: email || '',
              displayName: displayName || '',
              isDefault: email === defaultEmail
            };
          }
          return {
            email: item.email || item,
            displayName: item.display_name || '',
            isDefault: (item.email || item) === defaultEmail
          };
        });
        if (!newSenderEmails.some(item => item.isDefault)) {
          newSenderEmails[0].isDefault = true;
        }
        this.senderEmailsArray = newSenderEmails;
      } else if (this.emailSocialData?.from_email) {
        this.senderEmailsArray = [{
          email: this.emailSocialData.from_email,
          displayName: this.emailSocialData.from_display_name || '',
          isDefault: true
        }];
      }
    },
    async addSenderEmail() {
      const trimmedEmail = this.newSenderEmail.trim();
      if (!trimmedEmail) return;

      if (!this.isValidEmail(trimmedEmail)) {
        useUIStore().updateToast({ open: true, message: 'Please enter a valid email address.', type: 'danger', duration: 3000 });
        return;
      }

      // Sender emails must belong to the connection's verified domain.
      const domainCheck = validateSenderDomain(trimmedEmail, this.emailSocialData?.verified_domain);
      if (!domainCheck.valid) {
        useUIStore().updateToast({ open: true, message: `Sender email must use the verified domain @${domainCheck.verifiedDomain}.`, type: 'danger', duration: 3000 });
        return;
      }

      const alreadyExists = this.senderEmailsArray.some(item => item.email === trimmedEmail);
      if (alreadyExists) {
        useUIStore().updateToast({ open: true, message: 'Sender email already exists.', type: 'danger', duration: 2500 });
        return;
      }

      const isFirstEntry = this.senderEmailsArray.length === 0;
      const newEntry = {
        email: trimmedEmail,
        displayName: this.newDisplayName.trim(),
        isDefault: isFirstEntry
      };

      this.senderEmailsArray.push(newEntry);
      const savedEmail = this.newSenderEmail;
      const savedDisplayName = this.newDisplayName;
      this.newSenderEmail = '';
      this.newDisplayName = '';

      try {
        await this.updateEmail(false);
      } catch {
        // Revert the optimistic addition on failure
        this.senderEmailsArray = this.senderEmailsArray.filter(item => item.email !== trimmedEmail);
        this.newSenderEmail = savedEmail;
        this.newDisplayName = savedDisplayName;
      }
    },
    isValidEmail(value) {
      return isValidEmailHelper(value);
    },
    async updateEmail(isDelete) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: isDelete ? 'Deleting sender email...' : 'Updating Email account...' });
        const reqBody = {
          sender_ids: this.senderEmailsArray.map(item => item.displayName ? `${item.email}:${item.displayName}` : item.email),
        };
        await apiInterceptor.patch(EMAIL_API_BASE + '/' + this.emailSocialData.id, reqBody);
        const toastMessage = isDelete ? 'Sender email deleted successfully!' : 'Your Email account details are updated successfully!';
        useUIStore().updateToast({ open: true, message: toastMessage, type: 'success' });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Connection details just changed — re-check the verification status.
        await this.refreshChannel('email');
        this.syncConnectedConfigFromSocialData();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Something went wrong', type: 'danger' });
        throw error;
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async updateEmailChannelConfig() {
      try {
        if (!this.emailSocialData?.id) {
          useUIStore().updateToast({ open: true, message: 'Email connection not found.', type: 'danger' });
          return;
        }

        useUIStore().updateLoading({ isLoading: true, message: 'Updating Email settings...' });
        const reqBody = {
          applicationid: this.connectedAppId.trim(),
          privatekey: this.connectedPrivateKey.trim()
        };

        await apiInterceptor.patch(EMAIL_API_BASE + '/' + this.emailSocialData.id, reqBody);

        useUIStore().updateToast({ open: true, message: 'App ID and Private key updated successfully!', type: 'success' });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('email');
        this.initialConnectedAppId = this.connectedAppId.trim();
        this.initialConnectedPrivateKey = this.connectedPrivateKey.trim();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Failed to update Email settings.', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    setAsDefault(index) {
      if (this.senderEmailsArray.filter(i => i.isDefault).length === 1 && this.senderEmailsArray[index].isDefault) {
        return;
      }
      this.senderEmailsArray.forEach((item, i) => {
        item.isDefault = i === index;
      });
      this.updateDefaultSender();
    },
    async updateDefaultSender() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Updating default sender...' });
        const defaultSender = this.senderEmailsArray.find(item => item.isDefault);
        const reqBody = {
          from_email: defaultSender?.email || '',
          from_display_name: defaultSender?.displayName || ''
        };
        await apiInterceptor.patch(EMAIL_API_BASE + '/' + this.emailSocialData.id, reqBody);
        useUIStore().updateToast({ open: true, message: 'Default sender updated successfully!', type: 'success' });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        // Connection details just changed — re-check the verification status.
        await this.refreshChannel('email');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Something went wrong', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    deleteSenderEmail(email) {
      this.deleteEmailId = email;
      this.showDeleteConfirmation = true;
    },
    confirmDeleteSenderEmail() {
      this.showDeleteConfirmation = false;
      const wasDefault = this.senderEmailsArray.find(item => item.email === this.deleteEmailId)?.isDefault;
      this.senderEmailsArray = this.senderEmailsArray.filter(item => item.email !== this.deleteEmailId);
      if (wasDefault && this.senderEmailsArray.length > 0) {
        this.senderEmailsArray[0].isDefault = true;
      }
      this.deleteEmailId = '';
      this.updateEmail(true);
    }
  }
}
</script>

<style scoped>
.model-sections {
  background: var(--white);
  border-radius: 5px;
}
.channel-container {
  background: var(--white);
  border-radius: 5px;
  padding: 20px;
}
.flexContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}
.iconImg,
.emailLogo {
  width: 40px;
  height: 40px;
}
.channel-icon-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.channel-verification-badge {
  position: absolute;
  top: -6px;
  right: -6px;
}
.sender-row {
  display: grid;
  grid-template-columns: 3fr 2fr 3fr 1.5fr 1fr;
  align-items: center;
  padding: 10px 0;
}
.sender-header {
  border-bottom: 1px solid var(--background-primary);
  padding-bottom: 15px;
  margin-bottom: 10px;
}
.newsenderContainer {
  margin-top: 10px;
  padding-top: 20px;
}
.sender-cell {
  min-width: 0;
}
.sender-info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  padding: 12px 0;
}
.config-field-wrap {
  flex: 1;
  max-width: 560px;
}
.config-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.sender-info-row:last-child {
  border-bottom: none;
}
.senderKeysTotal {
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin: 0;
}
.senderContainer {
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.senderContainer::-webkit-scrollbar {
  width: 3px;
}
.text-right {
  text-align: right;
}
.vtext-muted {
  color: var(--gray);
  font-style: italic;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.vivid-textarea {
  background: var(--background-primary);
  border-radius: 5px;
  width: 100%;
  --textarea-background-color: var(--background-primary);
}
.vivid-textarea::part(control) {
  background-color: var(--background-primary);
}
.custPaddingRight {
  padding-right: 20px;
}
.colMargin {
  margin-bottom: 10px;
}
.margin10P {
  margin: 10px;
}
@media only screen and (max-width: 760px) {
  .custPaddingRight {
    padding-right: 0;
  }
}
</style>
